import { render, staticRenderFns } from "./userInfo.vue?vue&type=template&id=05f2cc56&scoped=true"
import script from "./userInfo.vue?vue&type=script&lang=js"
export * from "./userInfo.vue?vue&type=script&lang=js"
import style0 from "./userInfo.vue?vue&type=style&index=0&id=05f2cc56&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "05f2cc56",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/jenkins_home/workspace/Prod-平台矩阵/platform-miniprogram-cms/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('05f2cc56')) {
      api.createRecord('05f2cc56', component.options)
    } else {
      api.reload('05f2cc56', component.options)
    }
    module.hot.accept("./userInfo.vue?vue&type=template&id=05f2cc56&scoped=true", function () {
      api.rerender('05f2cc56', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/pages/userManagement/components/userInfo.vue"
export default component.exports